import { render, staticRenderFns } from "./EmailListInput.vue?vue&type=template&id=272af635&scoped=true"
import script from "./EmailListInput.vue?vue&type=script&lang=js"
export * from "./EmailListInput.vue?vue&type=script&lang=js"
import style0 from "./EmailListInput.vue?vue&type=style&index=0&id=272af635&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272af635",
  null
  
)

export default component.exports